import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../medieval-office-kit';

const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;
  const tcx = 950;
  const tcy = 220;

  // Council floor runner under the table
  place(ctx, kit.runnerRug(art, 200, 200), tcx, tcy);

  // Hero round table (interactive war-map renders separately on the north wall at 950,90)
  place(ctx, kit.roundTable(art, 62), tcx, tcy);

  // 8 council chairs ringing the table, each turned to face the centre
  const seats: ReadonlyArray<readonly [number, number]> = [
    [950, 140], [1017, 163], [1045, 220], [1017, 277],
    [950, 300], [883, 277], [855, 220], [883, 163],
  ];
  for (const [sx, sy] of seats) {
    place(ctx, kit.woodChair(art, Math.atan2(tcy - sy, tcx - sx)), sx, sy);
  }

  // West-wall crest tapestry (faces into the room) + a second campaign tapestry on the east wall.
  place(ctx, kit.tapestry(art, 72, 96, 'crest'), 846, 150);
  place(ctx, kit.tapestry(art, 64, 86, 'map'), 1058, 160);

  // Herald's lectern (S-centre) + the message-raven perched in the NE corner, well clear of any flame.
  place(ctx, kit.lectern(art), 978, 338);
  place(ctx, kit.raven(art), 894, 92);

  // Candlelit braziers in the two SOUTH corners (off the chairs, the lectern + the raven).
  place(ctx, kit.brazier(art), 852, 336);
  place(ctx, kit.brazier(art), 1048, 336);
};

export default decorate;
